import type { SVGProps } from 'react';

const SvgTimeDelay = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <g fill={props.color} data-name="time-delay">
      <path d="m28.23 9.94-3.1-3.17a.74.74 0 0 0-.54-.23.72.72 0 0 0-.53.23L22.4 8.44a12.7 12.7 0 0 0-6.49-2.22v-1h3.58a.75.75 0 0 0 .75-.75V1.21a.75.75 0 0 0-.75-.75h-8.66a.75.75 0 0 0-.75.75v3.28a.75.75 0 0 0 .75.75h3.58v1a12.78 12.78 0 1 0 12 6.64L28.23 11a.75.75 0 0 0 0-1.06M11.58 2h7.16v1.74h-7.16Zm3.58 28.28A11.28 11.28 0 1 1 26.44 19a11.29 11.29 0 0 1-11.28 11.24Zm10.4-18.68a13.2 13.2 0 0 0-2-2.18l1-1 2.05 2.1Z" />
      <path d="m21.72 12.29-4.46 4.07a3.3 3.3 0 0 0-2.1-.76 3.37 3.37 0 1 0 3 1.94l4.53-4.15Zm-6.56 8.53A1.86 1.86 0 1 1 17 19a1.86 1.86 0 0 1-1.84 1.82" />
    </g>
  </svg>
);

export default SvgTimeDelay;
